import * as React from 'react';
import clsx from 'clsx';

interface Props {
  className?: string;
  animateRouteTransition?: boolean;
  mainFooter?: boolean;
}

const PageContent: React.FunctionComponent<Props> = ({
  children,
  className,
  animateRouteTransition = true,
  mainFooter,
}) => {
  const fullClassName = clsx(
    'PageContent',
    {
      'Animation--routeTransitionAppear': animateRouteTransition,
      'MainFooter--fixed-footer-sibling': mainFooter,
    },
    className
  );

  return <div className={fullClassName}>{children}</div>;
};

export default PageContent;
